import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_takaful_provider", link: "/takaful-provider" }];

const TakafulProvider = Loadable({
  loader: () => import("../../container/takafulProvider"),
  loading() {
    return <Loader />;
  }
});
const TakafulProviderListing = Loadable({
  loader: () => import("../../container/takafulProvider/listing"),
  loading() {
    return <Loader />;
  }
});

export const TakafulProviderRoutes: IRoute[] = [
  {
    path: "/takaful-provider/details/:id?",
    element: <TakafulProvider />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  },
  {
    path: "/takaful-provider",
    element: <TakafulProviderListing />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
